/// <reference path="../_references.ts"/>

module App.PriceGuide {
	angular
		.module('priceGuide', [
		])
		.config(['$stateProvider', ($stateProvider: ng.ui.IStateProvider) => {
			$stateProvider
				.state('zipSolutions.price-guide', {
					url: 'price-guide',
					data: {
						title: 'Price Guide',
					},
					params: {
						packageId: null,
					},
					views: {
						'content@': {
							controller: 'PriceGuideController',
							controllerAs: 'ctrl',
							templateUrl: 'html/price-guide/price-guide.html',
						},
					},
				});
		}])
		.service('ProductService', ProductService.Factory())
		.controller('PriceGuideController', PriceGuideController);
}